import React, { useEffect, useMemo, useState } from 'react';
import ParticipantAccountSummaryTable from './ParticipantAccountSummaryTable';
import axios from "axios";
import { connect } from "react-redux";

const ParticipantAccountSummaryIndex = ({ organization , program }) => {
  const [programs, setPrograms] = useState([]);
  const [isLoadingPrograms, setIsLoadingPrograms] = useState(true);
  const [programLoadError, setProgramLoadError] = useState("");

  useEffect(() => {
    if (!organization?.id || !program?.id) {
      return undefined;
    }

    let isMounted = true;
    const orgId = program?.organization_id ?? organization?.id;
    const programsApiUrl = `/organization/${orgId}/program/${program.id}/descendents?includeSelf=1&flat=1&excludeArchived=true`;

    setIsLoadingPrograms(true);
    setProgramLoadError("");
    setPrograms([]);

    axios.get(programsApiUrl)
      .then((response) => {
        if (!isMounted) {
          return;
        }

        setPrograms(response.data || []);
      })
      .catch((error) => {
        if (!isMounted) {
          return;
        }

        setProgramLoadError(error?.message || "Unable to load participant account summary.");
      })
      .finally(() => {
        if (isMounted) {
          setIsLoadingPrograms(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [organization?.id, program?.id]);

  const defaultPrograms = useMemo(
    () => programs.map((item) => item.account_holder_id),
    [programs]
  );

  if (isLoadingPrograms) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        Loading participant account summary...
      </section>
    );
  }

  if (programLoadError) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        {programLoadError}
      </section>
    );
  }

  if (defaultPrograms.length === 0) {
    return (
      <section className="manager-report-panel manager-report-panel--state">
        No programs are available for this report.
      </section>
    );
  }

  return <ParticipantAccountSummaryTable programs={defaultPrograms} />;
}

const mapStateToProps = (state) => {
  return {
    organization: state.organization,
    program: state.program,
  };
};
export default connect(mapStateToProps)(ParticipantAccountSummaryIndex);
